import React from 'react';
import clsx from 'clsx';
import { Popup } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { errorMessage } from '@/utils/errors';
import Selectors from '@/themes/hooks/selectors';

const ValidationError = ({ children, error, position = 'bottom left' }) => {
  const intl = useIntl();
  const { theme } = Selectors.useTheme();
  return (
    <Popup
      className={clsx('aridhia-validation-error', `aridhia-theme-${theme}`)}
      content={error ? errorMessage(error, intl) : undefined}
      size="tiny"
      pinned
      open={error}
      position={position}
      wide
      disabled={!error}
      trigger={<div>{children}</div>}
    />
  );
};

export default ValidationError;
